<template xmlns="http://www.w3.org/1999/html">
  <div>
    <div v-if="detail_loader"
         style="position:absolute; top:0; right:0; bottom:0; left:0; padding-top: 25%;background-color:rgba(255,255,255,0.31)">
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-card style="margin-top: 15px;">
      <v-layout>
        <v-flex sx12 sm12 md12 lg9></v-flex>
        <v-flex sx12 sm12 md12 lg3>
          <v-flex xs12 sm12 md12 lg12 style="display: flex; justify-content: center; padding-bottom: 27px;">
            <v-btn slot="activator" class="white--text add_announcement text-xs-center" style="padding: 22px;"
                   @click="unblock_incident_user_dialog= true">
                Un-Block User
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>

    <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center; align-items: center; display: flex; justify-content: flex-start;">
            <v-flex xm12 sm6 md6 lg4 v-for="incident in incidents"
                    :key="incident.id">
              <v-card style="margin:10px; padding: 10px 15px 10px 15px; border-radius: 5px; border: 1px solid
              #9a9a9a;">
               <v-card-title style="padding: 5px !important;">
                  <v-flex style="display: flex">
                    <v-flex xs8 sm8 md8 lg8>
                      <h3 class="headline">{{incident.created_by_user.first_name}}{{" "}}
                        {{incident.created_by_user.last_name}}</h3>
                      <div style="color: #a0a0a0"> {{ "From: "}} {{incident.station_name.name}} </div>
                    </v-flex>
                    <v-flex xs4 sm4 md4 lg4 style="display: flex; justify-content: flex-end;">

                      <td style="text-transform: capitalize;">
                        <v-chip v-if="incident.incident_type.name == 'Trains Delayed'"
                                style="font-size: 12px; border-radius: 5px;" label small color="#FFE17B" text-color="#FD8D14">
                        {{incident.incident_type.name}}</v-chip>

                      <v-chip v-else-if="incident.incident_type.name == 'Trains Cancelled'"
                              style="font-size: 12px; border-radius: 5px;" label small color="#F99B7D"
                              text-color="#B04759">
                        {{incident.incident_type.name}}</v-chip>

                      <v-chip v-else-if="incident.incident_type.name == 'Station Overcrowded'"
                          style="font-size: 12px; border-radius: 5px;" label small color="#E1ECC8" text-color="#A0C49D">
                        {{incident.incident_type.name}}</v-chip>

                      <v-chip v-else-if="incident.incident_type.name == 'Water Logging'"
                          style="font-size: 12px; border-radius: 5px;" label small color="#C8FFE0" text-color="#33BBC5">
                        {{incident.incident_type.name}}</v-chip>

                      <v-chip v-else-if="incident.incident_type.name == 'Others'"
                          style="font-size: 12px; border-radius: 5px;" label small color="#FFECAF" text-color="#FFB07F">
                        {{incident.incident_type.name}}</v-chip>
                      </td>


                    </v-flex>
                  </v-flex>
                </v-card-title>

                <v-divider light></v-divider>

                <v-card-title style="padding: 12px 12px 5px 12px !important;">

                  <v-flex v-show="$vuetify.breakpoint.xs"> {{ incident.description }}</v-flex>
                  <v-flex style="height: 180px;" v-show="$vuetify.breakpoint.lg ||
                  $vuetify.breakpoint.md || $vuetify.breakpoint.sm"> {{ incident.description }}</v-flex>
                </v-card-title>

                <span v-if="incident.image_url != NULL">
                  <v-img
                    :src="storage_image_url + incident.image_url"
                    height="180px" style="max-height: 180px; border-radius: 10px; border: 1px solid #d2d0d0;"/>
                </span>
                <span v-else>
                <v-img  :src="storage_path() + 'incident-report.jpg'"
                       height="180px" style="max-height: 180px; border-radius: 10px; border: 1px solid #d2d0d0;"
                alt="incident image"></v-img>
                </span>
                  <v-container
                      fill-height
                      fluid
                      pa-2
                  >
                    <v-layout fill-height style="display: flex; align-content: flex-end; justify-content: flex-end;
                    align-items: flex-end;">
                        <v-chip style="font-size: 13px; border-radius: 8px; border: 2px solid #FFFFFF; padding: 13px 0px;"
                                label small
                                color="#000000"
                                text-color="#FFFFFF"> {{incident.publish_status}} </v-chip>
                    </v-layout>
                  </v-container>
                </v-img>

              </v-card>
            </v-flex>

      <!--      delete Incident dialog-->
      <v-dialog v-model="unblock_incident_user_dialog" scrollable :overlay="false" max-width="450px"
                transition="dialog-transition"
                hide-overlay persistent>
        <v-card>
          <v-card-title primary-title style="height: 100px;">
            <h2>Are you sure you wish to unblock this user?</h2>
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small color="error" @click="unblock_incident_user_dialog = false">Cancel</v-btn>
            <v-btn small color="primary" @click="UnblockedUser()" :loading="loaders.delete_loading">Confirm</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
          v-model="snackbar.display"
          :color="snackbar.color"
          :top="snackbar.top"
          :bottom="snackbar.bottom"
          :left="snackbar.left"
          :right="snackbar.right"
          :timeout="snackbar.timeout"
      >
        {{ snackbar.message }}
        <v-btn text dark @click="snackbar.display = false">
          <v-icon right color="white"> close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "BlockUserIncidents",
  data(){
    return {
      user_id: '',
      detail_loader: false,
      incidents: [],
      snackbar: {
        message: "",
        display: false,
        color: "black",
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000,
      },
      storage_image_url: "",
      loaders: {
        delete_loading: false,
      },
      unblock_incident_user_dialog: false,

    }
  },
  methods: {
    getUserIncidentUs() {
      this.detail_loader = true;
      // let formdata = new FormData();
      // formdata.append("user_id", this.$route.params.id)
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/get-user-wise-incidents/` + this.$route.params.id).then((response) => {
        if (response.data.status == 1) {
          this.detail_loader = false;
          this.incidents = response.data.data;
        } else if (response.data.status == 0) {
          this.detail_loader = false;
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.detail_loader = false;
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    },
    UnblockedUser(){
      this.startLoading();
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/unblock-incident-user`,{user_id: this.$route.params.id})
          .then((response) => {
        if (response.data.status == 1) {
          this.unblock_incident_user_dialog = false;
          this.stopLoading();
          this.$router.push({name: 'restricted-users'});
        } else if (response.data.status == 0) {
          this.unblock_incident_user_dialog = false;
          this.stopLoading();
          this.snackbar.message = response.data.message;
          this.snackbar.display = true
        }
      }).catch((error) => {
        this.unblock_incident_user_dialog = false;
        this.stopLoading();
        this.snackbar.message = "Something went wrong.";
        this.snackbar.display = true
      });
    }
  },
  mounted() {
    this.getUserIncidentUs();
    this.storage_image_url = process.env.VUE_APP_AZURE_STORAGE_URL + process.env.VUE_APP_AZURE_STORAGE_CONTAINER + "/";
  }
}
</script>

<style scoped>

</style>
